import buildHotelData from '@/js/common/Domain/Factory/service/buildHotelData';
import HotToursHotel from '../Entity/HotToursHotel';

export default (data) => {
    const hotel = buildHotelData(data);
    return new HotToursHotel(hotel);
};